import { CART_FETCH, CART_LOADING, CART_FAILED, CART_RESET, UPDATE_CART, REMOVE_FROM_CART } from '../actions/cartActions'
import { SHIPPING_PRICE, getEffectivePrice } from '../utils/itemPresentation'

export const initialState = {
  loading: false,
  results: [],
  error: null,
  total_items: 0,
  subtotal_price: 0,
  shipping_price: 0,
  total_price: 0,
  total_unique_items: 0
}

const recalculateCartState = (results) => {
  const normalizedResults = results.filter(Boolean)
  const subtotalPrice = normalizedResults.reduce((total, item) => {
    return total + (getEffectivePrice(item) * Number(item.count || 0))
  }, 0)
  const totalItems = normalizedResults.reduce((total, item) => total + Number(item.count || 0), 0)
  const shippingPrice = normalizedResults.length > 0 ? SHIPPING_PRICE : 0

  return {
    results: normalizedResults,
    total_items: totalItems,
    total_unique_items: normalizedResults.length,
    subtotal_price: subtotalPrice,
    shipping_price: shippingPrice,
    total_price: subtotalPrice + shippingPrice
  }
}

export const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case CART_LOADING:
      return { ...state, loading: true }
    case CART_FETCH:
      return {
        ...state,
        loading: false,
        results: action.payload.data,
        total_items: action.payload.total_items,
        subtotal_price: action.payload.subtotal_price ?? action.payload.total_price ?? 0,
        shipping_price: action.payload.shipping_price ?? 0,
        total_price: action.payload.total_price,
        total_unique_items: action.payload.total_unique_items
      }
    case CART_FAILED:
      return { ...state, loading: false, results: [], error: action.payload }
    case CART_RESET:
      return initialState
    case UPDATE_CART: {
      const newItem = action.payload
      const itemIndex = state.results.findIndex(item => item._id === newItem._id)

      let updatedResults = [...state.results]

      if (itemIndex !== -1) {
        if (newItem.count <= 0) {
          updatedResults = updatedResults.filter((_, index) => index !== itemIndex)
        } else {
          updatedResults[itemIndex] = { ...updatedResults[itemIndex], ...newItem, count: newItem.count }
        }
      } else if (newItem.count > 0) {
        updatedResults.push(newItem)
      }

      return {
        ...state,
        ...recalculateCartState(updatedResults),
        loading: false
      }
    }

    case REMOVE_FROM_CART: {
      const itemIdToRemove = action.payload
      const updatedResults = state.results.filter(item => item._id !== itemIdToRemove)

      return {
        ...state,
        ...recalculateCartState(updatedResults),
        loading: false
      }
    }

    default:
      return state
  }
}
